<template>
  <div id="portfolio" class="bg-primary">
    <div class="slider" @mouseenter="stopSlider" @mouseleave="startSlider">
      <div class="header txt-center">
        <div class="name">
          <h4>
            {{ slider[sliderIndex].name }}
            <span>stack: </span>
          </h4>
          <small>
            {{ slider[sliderIndex].stack }}
          </small>
        </div>
      </div>
      <div class="prev" @click="prev">
        <span></span>
        <span></span>
      </div>
      <div class="next" @click="next">
        <span></span>
        <span></span>
      </div>
      <transition
        :name="direction ? 'slide-leave' : 'slide-enter'"
        v-if="type == 'mobile'"
      >
        <div
          :class="['slider-img slider-img-mobile', showButton ? 'filter' : '']"
          @click="showButton = !showButton"
          v-for="el in [sliderIndex]"
          :key="el"
        >
          <a
            :href="slider[el].href"
            target="_blank"
            class="btn btn-outline"
            v-if="showButton"
          >
            Vai al progetto
          </a>
          <img
            :src="require(`@/img/portfolio/mobile/${slider[el].imgMobile}.png`)"
            :alt="slider[el].name"
          />
        </div>
      </transition>
      <transition
        :name="direction ? 'slide-leave' : 'slide-enter'"
        v-if="type == 'desktop'"
      >
        <div
          :class="['slider-img slider-img-desktop', showButton ? 'filter' : '']"
          @mouseover="showButton = true"
          @mouseleave="showButton = false"
          v-for="el in [sliderIndex]"
          :key="el"
        >
          <a
            :href="slider[el].href"
            target="_blank"
            class="btn btn-outline"
            v-if="showButton"
            @mouseover="showButton = true"
          >
            Vai al progetto
          </a>
          <img
            :src="
              require(`@/img/portfolio/desktop/${slider[el].imgDesktop}.png`)
            "
            :alt="slider[el].name"
          />
        </div>
      </transition>
      <div class="slider-map">
        <span
          v-for="(el, index) in slider"
          :key="index"
          :class="('active', index === sliderIndex ? 'active' : '')"
          @click="sliderMapEl(index)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      slider: [
        {
          name: "boolean tv",
          stack: "html - css - VueJS - Api(Ajax)",
          imgDesktop: "booleantv-desktop",
          imgMobile: "booleantv-mobile",
          href: "https://github.com/IvanDF/vue-boolflix"
        },
        {
          name: "DeliveBoo",
          stack: "html - scss - VueJS - PHP - Laravel - MySQL",
          imgDesktop: "deliveroo-desktop",
          imgMobile: "deliveroo-mobile",
          href: "https://github.com/FrancescaCassani/deliveroo.git"
        },
        {
          name: "Digital Ocean",
          stack: "html - css",
          imgDesktop: "digitalcean-desktop",
          imgMobile: "digitalcean-mobile",
          href: "https://github.com/IvanDF/html-css-digitalocean.git"
        },
        {
          name: "Helbiz",
          stack: "html - css",
          imgDesktop: "helbiz-desktop",
          imgMobile: "helbiz-mobile",
          href: "https://github.com/IvanDF/html-css-helbiz.git"
        },
        {
          name: "iAccademy",
          stack: "html - css - VueJS",
          imgDesktop: "iaccademy-desktop",
          imgMobile: "iaccademy-mobile",
          href: "https://github.com/IvanDF/proj-html-vuejs.git"
        },
        {
          name: "La Molisana",
          stack: "html - scss - VueJS - PHP - Laravel",
          imgDesktop: "molisana-desktop",
          imgMobile: "molisana-mobile",
          href: "https://github.com/IvanDF/laravel-molisana.git"
        },
        {
          name: "Spotify",
          stack: "html - css - javascript",
          imgDesktop: "spotify-desktop",
          imgMobile: "spotify-mobile",
          href: "https://github.com/IvanDF/html-css-spotifyweb.git"
        },
        {
          name: "Todo List",
          stack: "html - scss - VueJS - PHP - Laravel - Api(Ajax) - MySQL",
          imgDesktop: "todo-desktop",
          imgMobile: "todo-mobile",
          href: "https://github.com/IvanDF/todo-fullstack.git"
        }
      ],
      // button for goto project
      showButton: false,
      // boolean for direction fo slides
      direction: false,
      sliderIndex: 0,

      // stack text
      changeStack: false,
      stackText: "",
      type: null
    };
  },
  mounted() {
    const mediaScreenDesktop = window.matchMedia("(min-width: 768px)");
    if (mediaScreenDesktop.matches) {
      this.type = "desktop";
    } else {
      this.type = "mobile";
    }
    addEventListener("resize", () => {
      if (mediaScreenDesktop.matches) {
        this.type = "desktop";
      } else {
        this.type = "mobile";
      }
    });
  },
  created() {
    this.startSlider();
  },
  methods: {
    next() {
      this.sliderIndex++;
      this.direction = false;

      if (this.sliderIndex > this.slider.length - 1) {
        this.sliderIndex = 0;
      }
    },
    prev() {
      this.sliderIndex--;
      this.direction = true;

      if (this.sliderIndex < 0) {
        this.sliderIndex = this.slider.length - 1;
      }
    },
    sliderMapEl(index) {
      if (this.sliderIndex <= index) {
        this.direction = false;
      } else {
        this.direction = true;
      }
      this.sliderIndex = index;
    },
    startSlider() {
      this.intervalId = setInterval(() => {
        this.next();
      }, 5000);
    },
    stopSlider() {
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style lang="scss">
#portfolio {
  @include d-flex("center");
  height: 100vh;
  overflow: hidden;
  .slider {
    @include d-flex("center");
    position: relative;
    height: 100%;
    width: 80%;
    max-width: 1100px;
    .header {
      @include center("ab-x");
      width: 100%;
      top: 75px;
      left: 50%;
      span {
        display: inline;
        color: palette(1);
        font-size: 1.2rem;
      }
    }
    .slider-img-mobile {
      position: absolute;
      display: flex;
      width: 80%;
      max-width: 280px;
      max-height: 70%;
      margin: 10px 0 15px;
      border: solid 5px palette(1);
      border-radius: 20px;
      overflow: hidden;
      img {
        display: flex;
        height: 100%;
        width: 1300px;
        max-width: 100%;
        justify-content: center;
        align-items: center;
      }
      &.filter {
        display: block;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        .btn {
          @include center("ab-xy");
          border-radius: 15px;
          width: 200px;
          font-size: 1rem;
          z-index: 1;
        }
        &::after {
          content: "";
          @include center("ab-xy");
          width: 100%;
          height: 100%;
          background: rgba(palette(2), 0.5);
        }
      }
    }
    span {
      display: block;
      height: 5px;
      width: 30px;
    }
    .prev,
    .next {
      @include center("ab-y");
      z-index: 2;
      cursor: pointer;
    }
    .prev {
      left: -30px;
      span {
        background: linear-gradient(90deg, palette(4), palette(3));
        &:first-child {
          transform: rotate(-45deg) translateY(-190%);
        }
        &:last-child {
          transform: rotate(45deg) translateY(190%);
        }
      }
    }
    .next {
      right: -30px;
      span {
        background: linear-gradient(90deg, palette(3), palette(4));
        &:first-child {
          transform: rotate(45deg) translateY(-190%);
        }
        &:last-child {
          transform: rotate(-45deg) translateY(190%);
        }
      }
    }
    .slider-map {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      @include center("ab-x");
      bottom: 75px;
      width: auto;
      span {
        display: inline-block;
        height: 5px;
        width: 30px;
        border-radius: 20px;
        background: rgba(palette(3), 0.5);
        margin-right: 10px;
        margin-top: 10px;
        cursor: pointer;
        &.active {
          background: palette(4);
        }
      }
    }
  }
}

.slide-enter-leave-active,
.slide-enter-enter-active,
.slide-leave-leave-active,
.slide-leave-enter-active {
  transition: transform 850ms cubic-bezier(0.645, 0.045, 0.355, 1);
}
.slide-enter-enter {
  opacity: 0;
  transform: translate(150%, 0) scale(1.3) skew(-7deg);
}
.slide-enter-leave-to {
  opacity: 1;
  transform: translate(-150%, 0) scale(0.6) skew(-7deg);
}
.slide-leave-enter {
  transform: translate(-150%, 0) scale(1.3) skew(7deg);
}
.slide-leave-leave-to {
  transform: translate(150%, 0) scale(0.6) skew(7deg);
}

@media screen and(min-width: 768px) {
  #portfolio {
    .slider {
      .header {
        top: 15px;
        span {
          display: inline;
          color: palette(1);
          font-size: 1.5rem;
        }
      }
      .slider-img-desktop {
        position: absolute;
        display: block;
        width: 100%;
        max-height: 70%;
        border-radius: 20px;
        border: solid 5px #ddd;
        overflow: hidden;
        img {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
        }
        &.filter {
          display: block;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          .btn {
            @include center("ab-xy");
            border-radius: 15px;
            width: 200px;
            font-size: 1rem;
            z-index: 1;
          }
          &::after {
            content: "";
            @include center("ab-xy");
            width: 100%;
            height: 100%;
            background: rgba(palette(2), 0.5);
          }
        }
      }
      .slider-map {
        display: flex;
        bottom: 35px;
      }
    }
  }
}
</style>
